import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-authorization',
  templateUrl: './service-authorization.component.html',
  styleUrls: ['./service-authorization.component.scss']
})
export class ServiceAuthorizationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
